import { AirwayConstants } from '../airway/store/airway.constants'
import { CardioConstants } from '../cardio/store/cardio.constants'
import { MotorSensoryAssessmentConstants } from '../neuro/motorSensoryAssessment/store/motoSensoryAssessment.constants'
import { PupilsConstants } from '../neuro/pupils/store/pupils.constants'
import { WasPatientImmobilizedConstants } from '../neuro/wasPatientImmobilized/store/wasPatientImmobilized.constants'
import { RespiratoryConstant } from '../respiratory/store/respiratory.constant'

export const initialAssessmentSchemas = [
  {
    inputKey: CardioConstants.SET_PMMODE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PMMODE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PMMODE'],
    errorMessage: {
      properties: {
        SET_PMMODE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: MotorSensoryAssessmentConstants.SET_MOTORCOMMENTS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MOTORCOMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MOTORCOMMENTS'],
    errorMessage: {
      properties: {
        SET_MOTORCOMMENTS: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: MotorSensoryAssessmentConstants.SET_HEADSENSORY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_HEADSENSORY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_HEADSENSORY'],
    errorMessage: {
      properties: {
        SET_HEADSENSORY: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: PupilsConstants.SET_HEADREACTIVE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_HEADREACTIVE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_HEADREACTIVE'],
    errorMessage: {
      properties: {
        SET_HEADREACTIVE: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: CardioConstants.SET_MA,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MA: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,3}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MA'],
    errorMessage: {
      properties: {
        SET_MA: 'Ma must be numeric with max length of 3',
      },
    },
  },
  {
    inputKey: CardioConstants.SET_RATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RATE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,3}$',
      },
    },
    additionalProperties: false,
    required: ['SET_RATE'],
    errorMessage: {
      properties: {
        SET_RATE: 'Rate must be numeric with max length of 3',
      },
    },
  },
  {
    inputKey: AirwayConstants.SET_TUBE_SIZE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TUBE_SIZE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_TUBE_SIZE'],
    errorMessage: {
      properties: {
        SET_TUBE_SIZE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: AirwayConstants.SET_DEPTH,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DEPTH: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DEPTH'],
    errorMessage: {
      properties: {
        SET_DEPTH: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: WasPatientImmobilizedConstants.SET_COLLAR,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COLLAR: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,4000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COLLAR'],
    errorMessage: {
      properties: {
        SET_COLLAR: 'Must be alphanumeric with max length of 4000',
      },
    },
  },
  {
    inputKey: WasPatientImmobilizedConstants.SET_CID,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CID: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,4000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CID'],
    errorMessage: {
      properties: {
        SET_CID: 'Must be alphanumeric with max length of 4000',
      },
    },
  },
  {
    inputKey: WasPatientImmobilizedConstants.SET_LBB,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LBB: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,4000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LBB'],
    errorMessage: {
      properties: {
        SET_LBB: 'Must be alphanumeric with max length of 4000',
      },
    },
  },
  {
    inputKey: WasPatientImmobilizedConstants.SET_KED,
    isNumber: false,
    type: 'object',
    properties: {
      SET_KED: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,4000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_KED'],
    errorMessage: {
      properties: {
        SET_KED: 'Must be alphanumeric with max length of 4000',
      },
    },
  },
  {
    inputKey: WasPatientImmobilizedConstants.SET_MAST,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MAST: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,4000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MAST'],
    errorMessage: {
      properties: {
        SET_MAST: 'Must be alphanumeric with max length of 4000',
      },
    },
  },
  {
    inputKey: RespiratoryConstant.SET_O2,
    isNumber: false,
    type: 'object',
    properties: {
      SET_O2: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_O2'],
    errorMessage: {
      properties: {
        SET_O2: 'O2 must be numeric with max length of 50',
      },
    },
  },
  {
    inputKey: RespiratoryConstant.SET_RFIO2,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RFIO2: {
        type: 'string',
        pattern: '^$|^-?\\d+(\\.\\d{1,2})?$',
      },
    },
    additionalProperties: false,
    required: ['SET_RFIO2'],
    errorMessage: {
      properties: {
        SET_RFIO2: 'FiO2 must be a numeric value.  Decimal values support two digits of precision.',
      },
    },
  },
  {
    inputKey: RespiratoryConstant.SET_FIO2AirTemp,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIO2AirTemp: {
        type: 'string',
        pattern: '^$|^\\d+(\\.\\d{1,1})?$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIO2AirTemp'],
    errorMessage: {
      properties: {
        SET_FIO2AirTemp: 'Air Temp must be a positive value.  Decimal values support one digit of precision.',
      },
    },
  },
  {
    inputKey: RespiratoryConstant.SET_FIO2Humidity,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIO2Humidity: {
        type: 'string',
        pattern: '^(?:100|\\d{1,2}|0+)$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIO2Humidity'],
    errorMessage: {
      properties: {
        SET_FIO2Humidity: 'Humidity must be a positive whole number with max of 100.',
      },
    },
  },
]
